export default import.meta.ROLLDOWN_FILE_URL_PavOJady9TG7Z1KlGPtWqA